import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Logo } from "@/components/Logo";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setErr(""); setLoading(true);
    const r = await register(form);
    setLoading(false);
    if (r.ok) { toast.success("Account created! Let's start."); nav("/app"); }
    else setErr(r.error);
  }

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:flex relative overflow-hidden bg-gradient-to-br from-[#0B1B3A] to-[#1E3A8A] grain">
        <div className="absolute -top-20 -right-10 h-80 w-80 rounded-full bg-teal/30 blur-3xl" />
        <div className="absolute -bottom-16 -left-16 h-72 w-72 rounded-full bg-magenta/25 blur-3xl" />
        <div className="relative z-10 flex flex-col justify-between p-10 text-white w-full">
          <Logo size={60} onLight={false} linkTo={null} />
          <div>
            <h2 className="font-display text-5xl font-bold tracking-tight leading-tight">
              Build Skills. Create <span className="text-teal">Opportunities.</span><br />
              Transform Your <span className="text-gold">Career.</span>
            </h2>
            <p className="mt-4 max-w-md text-white/85">
              Get instant access to 16 premium programs, live cohorts, community and verified certificates.
            </p>
          </div>
          <p className="text-xs text-white/60">Channel Partner – NVDigitalEdu</p>
        </div>
      </div>

      <div className="flex items-center justify-center px-6 py-14 bg-background">
        <div className="w-full max-w-md">
          <div className="lg:hidden mb-8"><Logo size={44} /></div>
          <h1 className="font-display text-4xl font-bold tracking-tight">Create account</h1>
          <p className="text-muted-foreground mt-2">It's free. Upgrade to any program anytime.</p>

          <form onSubmit={submit} className="mt-8 space-y-4" data-testid="register-form">
            <div>
              <Label>Full name</Label>
              <Input data-testid="reg-name" required value={form.name}
                onChange={(e) => setForm({ ...form, name: e.target.value })}
                className="mt-1.5 rounded-xl h-11" />
            </div>
            <div>
              <Label>Email</Label>
              <Input data-testid="reg-email" type="email" required value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                className="mt-1.5 rounded-xl h-11" />
            </div>
            <div>
              <Label>Mobile (optional)</Label>
              <Input data-testid="reg-phone" value={form.phone}
                onChange={(e) => setForm({ ...form, phone: e.target.value })}
                className="mt-1.5 rounded-xl h-11" />
            </div>
            <div>
              <Label>Password (min 6 chars)</Label>
              <Input data-testid="reg-password" type="password" required minLength={6}
                value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
                className="mt-1.5 rounded-xl h-11" />
            </div>
            {err && <p data-testid="reg-error" className="text-sm text-destructive">{err}</p>}
            <Button type="submit" data-testid="reg-submit" disabled={loading}
              className="w-full h-11 rounded-xl royal-gradient border-0 text-white btn-lift">
              {loading ? "Creating..." : "Create account"}
            </Button>
          </form>

          <p className="text-sm text-center text-muted-foreground mt-6">
            Already have an account?{" "}
            <Link to="/login" className="text-primary font-semibold hover:underline">Sign in</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
